import { effect, Injectable, signal } from '@angular/core';

const LOCAL_STORAGE_PREFIX = 'edu';

@Injectable()
export class LocalStorageService {
  public storageSignal<T>(key: string, initial: T) {
    key = `${LOCAL_STORAGE_PREFIX}-${key}`;

    // Try to read from localStorage first
    const stored = localStorage.getItem(key);
    const value = stored ? (JSON.parse(stored) as T) : initial;

    const state = signal<T>(value);

    // Keep localStorage in sync whenever the signal changes
    effect(() => {
      localStorage.setItem(key, JSON.stringify(state()));
    });

    return state;
  }
}
